import React, { useEffect, useState } from 'react';

import styled from 'styled-components';
import Templates from './Templates';
import StarterPrompt from './StarterPrompt/StarterPrompt';
import Controls from './Controls/Controls';
import { useSelector, useDispatch } from 'react-redux';
import useMediaQuery from 'container/hooks/useMediaQuery';
const ImageGeneration = ({ sideBar }) => {
  const [step, setStep] = useState(1);

  const isDesktop = useMediaQuery('(max-width: 1000px)');
  const isLeftSideOpen = useSelector(state => state.utils.isLeftSideBarOpen);
  const isRightSideOpen = useSelector(state => state.utils.isRightSideBarOpen);
  const { openControls } = useSelector(state => state.utils);
  const planData = useSelector(state => state.subscription.planData);

  const dispatch = useDispatch();

  const open = useSelector(state => state.utils.openControls);
  const handleClick = s => {
    setStep(s);
  };

  useEffect(() => {
    dispatch.imageGeneration.setPromptEdited(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (openControls && !isRightSideOpen) {
      dispatch.utils.setRightSideBar(true);
    }
    // eslint-disable-next-line
  }, [openControls, isRightSideOpen]);

  return (
    <Container
      className={planData?.plan?.toLowerCase() === 'free' ? 'banner' : ''}
    >
      <div
        className='container'
        style={{ borderRadius: open ? '12px 0px 0px 12px' : '12px' }}
      >
        {!isDesktop && (
          <div
            className='left-side-icon'
            onClick={() => dispatch.utils.setLeftSideBar(!isLeftSideOpen)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              fill='currentColor'
              className='bi bi-chevron-left left'
              viewBox='0 0 16 16'
              style={{
                transform: !isLeftSideOpen ? 'rotate(0deg)' : 'rotate(180deg)',
              }}
            >
              <path
                fillRule='evenodd'
                stroke={'#ffffff'}
                strokeWidth='2'
                d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'
              />
            </svg>
          </div>
        )}
        {!isDesktop && (
          <div
            className={`right-side-icon ${openControls ? 'disabled' : ''}`}
            onClick={() => {
              if (openControls) {
                return;
              }
              dispatch.utils.setRightSideBar(!isRightSideOpen);
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='15'
              fill='currentColor'
              className='bi bi-chevron-right right'
              viewBox='0 0 16 16'
              style={{
                transform: !isRightSideOpen && 'rotate(180deg)',
              }}
            >
              <path
                fillRule='evenodd'
                stroke={'#ffffff'}
                strokeWidth='2'
                d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'
              />
            </svg>
          </div>
        )}
        {(step === 1 || step === 3) && (
          <Templates step={step} setStep={setStep} handleClick={handleClick} />
        )}
        {step === 2 && <StarterPrompt handleClick={handleClick} />}
      </div>
      <Controls sideBar={sideBar} />
    </Container>
  );
};

export default ImageGeneration;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 0px 7px;
  position: relative;
  width: 100%;
  height: 100%;
  flex-grow: 1;

  & .container {
    height: 100%;
    background-color: ${({ theme }) => theme.colors.darkgrey};
    display: flex;
    flex-direction: column;
    padding: 0px;
    z-index: 20;
    transition: 0.4s ease;
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: 1000px) {
    height: 100vh;
    &.banner {
      height: calc(100vh - 45px);
    }
  }
  & .left-side-icon,
  .right-side-icon {
    background-color: #74aa9c;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 40px;
    width: 40px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    cursor: pointer;
    z-index: 100;
  }

  & .left-side-icon {
    transform: translate(-50%, -50%);
  }
  & .right-side-icon {
    transform: translate(50%, -50%);
    right: 0px;
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;
